import { OrganizationTypeWithLinkedProfessions, Profession, SpecialismCode } from '@common/enums';

const ggzOrganizationBigAllowedProfessions = {
    addictionSpecialist: Profession.addictionSpecialist,
    clinicalPsychologist: Profession.clinicalPsychologist,
    gzPsychologist: Profession.gzPsychologist,
    medicalSpecialist: Profession.medicalSpecialist,
    nurse: Profession.nurse,
    nurseSpecialist: Profession.nurseSpecialist,
    psychotherapist: Profession.psychotherapist,
    remedialEducationalist: Profession.remedialEducationalist,
    socialPedagogicalCareProvider: Profession.socialPedagogicalCareProvider,
    socialPsychiatricNurses: Profession.socialPsychiatricNurses,
    systemTherapist: Profession.systemTherapist,
};

export const identifierRegistrationBigAllowedByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {},
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {},
    [OrganizationTypeWithLinkedProfessions.hospital]: {
        assistant: Profession.assistant,
        basicPractitioner: Profession.basicPractitioner,
        clinicalPsychologist: Profession.clinicalPsychologist,
        dietitian: Profession.dietitian,
        exerciseTherapist: Profession.exerciseTherapist,
        gzPsychologist: Profession.gzPsychologist,
        medicalSpecialist: Profession.medicalSpecialist,
        nurse: Profession.nurse,
        nurseConsultant: Profession.nurseConsultant,
        nurseSpecialist: Profession.nurseSpecialist,
        obstetrician: Profession.obstetrician,
        occupationalTherapist: Profession.occupationalTherapist,
        phdStudent: Profession.phdStudent,
        physicianAssistant: Profession.physicianAssistant,
        physiotherapist: Profession.physiotherapist,
        podiatrist: Profession.podiatrist,
        speechTherapist: Profession.speechTherapist,
    },
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {
        bariNurse: Profession.bariNurse,
        medicalSpecialist: Profession.medicalSpecialist,
        osasNurse: Profession.osasNurse,
    },
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {},
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]:
        ggzOrganizationBigAllowedProfessions,
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: ggzOrganizationBigAllowedProfessions,
    [OrganizationTypeWithLinkedProfessions.independentPractice]: ggzOrganizationBigAllowedProfessions,
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {
        addictionSpecialist: Profession.addictionSpecialist,
        basicPractitioner: Profession.basicPractitioner,
        medicalSpecialist: Profession.medicalSpecialist,
        nurse: Profession.nurse,
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {},
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {
        basicPractitioner: Profession.basicPractitioner,
        nurse: Profession.nurse,
        nurseSpecialist: Profession.nurseSpecialist,
        resident: Profession.resident,
        specialistGeriatricMedicine: Profession.specialistGeriatricMedicine,
    },
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {},
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {
        medicalSpecialist: Profession.medicalSpecialist,
        nurseSpecialist: Profession.nurseSpecialist,
        resident: Profession.resident,
    },
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {
        addictionSpecialist: Profession.addictionSpecialist,
        basicPractitioner: Profession.basicPractitioner,
        clinicalPsychologist: Profession.clinicalPsychologist,
        gzPsychologist: Profession.gzPsychologist,
        medicalSpecialist: Profession.medicalSpecialist,
        nurse: Profession.nurse,
        nurseSpecialist: Profession.nurseSpecialist,
        resident: Profession.resident,
    },
};

export const identifierRegistrationBigAllowed = [
    Profession.addictionSpecialist,
    Profession.assistant,
    Profession.clinicalPsychologist,
    Profession.cognitiveBehavioralTherapist,
    Profession.dentist,
    Profession.emdrTherapist,
    Profession.functionAssistant,
    Profession.gzPsychologist,
    Profession.haptotherapist,
    Profession.imhSpecialist,
    Profession.lossMentor,
    Profession.medicalSpecialist,
    Profession.nurse,
    Profession.nursePractitioner,
    Profession.nursePractitionerMentalHealth,
    Profession.nursePractitionerSomatic,
    Profession.nurseSpecialist,
    Profession.obstetrician,
    Profession.optician,
    Profession.orthoptist,
    Profession.other,
    Profession.outpatientAssistant,
    Profession.pharmacist,
    Profession.physicianAssistantOphthalmology,
    Profession.physiotherapist,
    Profession.basicPsychologist,
    Profession.psychosocialHypnotherapist,
    Profession.psychotherapist,
    Profession.relationshipAndFamilyTherapist,
    Profession.remedialEducationalist,
    Profession.resident,
    Profession.sexologist,
    Profession.socialPedagogicalCareProvider,
    Profession.socialPsychiatricNurses,
    Profession.socialWorker,
    Profession.specialistGeriatricMedicine,
    Profession.systemTherapist,
    Profession.technicalOphthalmicAssistant,
    Profession.teenageCoach,
    Profession.visualTherapist,
];

export const identifierRegistrationKpRequiredByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {},
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {},
    [OrganizationTypeWithLinkedProfessions.hospital]: {},
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {},
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {
        optometrist: Profession.optometrist,
        orthoptist: Profession.orthoptist,
    },
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: {},
    [OrganizationTypeWithLinkedProfessions.independentPractice]: {},
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {},
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {},
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {},
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {},
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {},
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {},
};

export const identifierRegistrationKpAllowed = [
    Profession.dietitian,
    Profession.skinTherapist,
    Profession.laborant,
    Profession.speechTherapist,
    Profession.optometrist,
];

export const supervisorRequiredByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {
        generalPractitionerAios: Profession.generalPractitionerAios,
        generalPractitionerHidha: Profession.generalPractitionerHidha,
        generalPractitionerWaarnemer: Profession.generalPractitionerWaarnemer,
    },
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {
        generalPractitionerAios: Profession.generalPractitionerAios,
        generalPractitionerHidha: Profession.generalPractitionerHidha,
        generalPractitionerWaarnemer: Profession.generalPractitionerWaarnemer,
    },
    [OrganizationTypeWithLinkedProfessions.hospital]: {},
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {},
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {},
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: {},
    [OrganizationTypeWithLinkedProfessions.independentPractice]: {},
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {},
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {},
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {
        resident: Profession.resident,
    },
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {},
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {
        resident: Profession.resident,
    },
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {
        resident: Profession.resident,
    },
};

export const supervisorRequired = [
    Profession.resident,
    Profession.physiotherapist,
    Profession.generalPractitionerHidha,
    Profession.generalPractitionerAios,
    Profession.generalPractitionerWaarnemer,
    Profession.clinicalPsychologist,
    Profession.addictionSpecialist,
    Profession.specialistGeriatricMedicine,
];

export const identifierDeclarationOrSupervisorRequiredByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {
        basicPractitioner: Profession.basicPractitioner,
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {
        basicPractitioner: Profession.basicPractitioner,
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.hospital]: {
        basicPractitioner: Profession.basicPractitioner,
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {
        bariNurse: Profession.bariNurse,
    },
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {},
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]: {
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: {
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.independentPractice]: {
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {
        basicPractitioner: Profession.basicPractitioner,
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {},
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {
        basicPractitioner: Profession.basicPractitioner,
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {},
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {
        nurseSpecialist: Profession.nurseSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {
        basicPractitioner: Profession.basicPractitioner,
        nurseSpecialist: Profession.nurseSpecialist,
    },
};

export const identifierDeclarationOrSupervisorRequired = [Profession.nurseSpecialist, Profession.basicPractitioner];

const ggzOrganizationidentifierDeclarationRequiredProfessions = {
    addictionSpecialist: Profession.addictionSpecialist,
    clinicalPsychologist: Profession.clinicalPsychologist,
    gzPsychologist: Profession.gzPsychologist,
    medicalSpecialist: Profession.medicalSpecialist,
    psychotherapist: Profession.psychotherapist,
    systemTherapist: Profession.systemTherapist,
};

export const identifierDeclarationRequiredByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {
        generalPractitioner: Profession.generalPractitioner,
        generalPractitionerMentalHealthSpecialist: Profession.generalPractitionerMentalHealthSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {
        generalPractitioner: Profession.generalPractitioner,
        generalPractitionerMentalHealthSpecialist: Profession.generalPractitionerMentalHealthSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.hospital]: {
        clinicalPsychologist: Profession.clinicalPsychologist,
        dietitian: Profession.dietitian,
        exerciseTherapist: Profession.exerciseTherapist,
        gzPsychologist: Profession.gzPsychologist,
        medicalSpecialist: Profession.medicalSpecialist,
        nurseConsultant: Profession.nurseConsultant,
        obstetrician: Profession.obstetrician,
        occupationalTherapist: Profession.occupationalTherapist,
        physiotherapist: Profession.physiotherapist,
        podiatrist: Profession.podiatrist,
        speechTherapist: Profession.speechTherapist,
    },
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {
        medicalSpecialist: Profession.medicalSpecialist,
        osasNurse: Profession.osasNurse,
    },
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {},
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]:
        ggzOrganizationidentifierDeclarationRequiredProfessions,
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: ggzOrganizationidentifierDeclarationRequiredProfessions,
    [OrganizationTypeWithLinkedProfessions.independentPractice]:
        ggzOrganizationidentifierDeclarationRequiredProfessions,
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {
        addictionSpecialist: Profession.addictionSpecialist,
        medicalSpecialist: Profession.medicalSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {},
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {
        specialistGeriatricMedicine: Profession.specialistGeriatricMedicine,
    },
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {
        skinTherapist: Profession.skinTherapist,
    },
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {},
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {
        medicalSpecialist: Profession.medicalSpecialist,
    },
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {
        addictionSpecialist: Profession.addictionSpecialist,
        clinicalPsychologist: Profession.clinicalPsychologist,
        gzPsychologist: Profession.gzPsychologist,
        medicalSpecialist: Profession.medicalSpecialist,
    },
};

export const identifierDeclarationRequired = [
    Profession.generalPractitioner,
    Profession.generalPractitionerMentalHealthSpecialist,
    Profession.medicalSpecialist,
    Profession.gzPsychologist,
];

export const identifierDeclarationAllowedByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.gpPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.gpPractice
        ],
        nurse: Profession.nurse,
        nursePractitionerMentalHealth: Profession.nursePractitionerMentalHealth,
        nursePractitionerSomatic: Profession.nursePractitionerSomatic,
        physicianAssistant: Profession.physicianAssistant,
        practiceManager: Profession.practiceManager,
    },
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.testOrganization],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.testOrganization
        ],
        nurse: Profession.nurse,
        nursePractitionerMentalHealth: Profession.nursePractitionerMentalHealth,
        nursePractitionerSomatic: Profession.nursePractitionerSomatic,
        physicianAssistant: Profession.physicianAssistant,
        practiceManager: Profession.practiceManager,
    },
    [OrganizationTypeWithLinkedProfessions.hospital]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.hospital],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.hospital],
        assistant: Profession.assistant,
        nurse: Profession.nurse,
        phdStudent: Profession.phdStudent,
        physicianAssistant: Profession.physicianAssistant,
    },
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.ksyosHospital],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.ksyosHospital
        ],
    },
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.optometryPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.optometryPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]: {
        ...identifierDeclarationRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice
        ],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice
        ],
        nurse: Profession.nurse,
        remedialEducationalist: Profession.remedialEducationalist,
    },
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.ggzInstitution],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.ggzInstitution
        ],
        nurse: Profession.nurse,
        remedialEducationalist: Profession.remedialEducationalist,
    },
    [OrganizationTypeWithLinkedProfessions.independentPractice]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.independentPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.independentPractice
        ],
        nurse: Profession.nurse,
        remedialEducationalist: Profession.remedialEducationalist,
    },
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.addictionCareCentre],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.addictionCareCentre
        ],
        nurse: Profession.nurse,
    },
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.dietitianPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.dietitianPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.nursingFacility],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.nursingFacility
        ],
        nurse: Profession.nurse,
    },
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.skinTherapyPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.skinTherapyPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {
        ...identifierDeclarationRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory
        ],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory
        ],
    },
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {
        ...identifierDeclarationRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare
        ],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare
        ],
    },
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {
        ...identifierDeclarationRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.psychiatryCenter],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.psychiatryCenter
        ],
        nurse: Profession.nurse,
    },
};

export const identifierDeclarationAllowed = [
    ...identifierDeclarationOrSupervisorRequired,
    ...identifierDeclarationRequired,
    Profession.pharmacist,
    Profession.assistant,
    Profession.dietitian,
    Profession.skinTherapist,
    Profession.laborant,
    Profession.speechTherapist,
    Profession.optometrist,
    Profession.nursePractitioner,
    Profession.basicPsychologist,
    Profession.psychotherapist,
    Profession.dentist,
    Profession.obstetrician,
    Profession.other,
    Profession.socialPsychiatricNurses,
    Profession.remedialEducationalist,
    Profession.sexologist,
    Profession.teenageCoach,
    Profession.systemTherapist,
    Profession.cognitiveBehavioralTherapist,
    Profession.imhSpecialist,
    Profession.relationshipAndFamilyTherapist,
    Profession.lossMentor,
    Profession.socialWorker,
    Profession.visualTherapist,
    Profession.socialPedagogicalCareProvider,
    Profession.emdrTherapist,
    Profession.haptotherapist,
    Profession.psychosocialHypnotherapist,
    Profession.optician,
    Profession.technicalOphthalmicAssistant,
    Profession.orthoptist,
    Profession.physicianAssistantOphthalmology,
    Profession.functionAssistant,
    Profession.nursePractitionerMentalHealth,
    Profession.nursePractitionerSomatic,
    Profession.outpatientAssistant,
    Profession.practiceManager,
    Profession.nurse,
    Profession.physicianAssistant,
];

export const supervisorAllowedByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.gpPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.gpPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.testOrganization],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.testOrganization
        ],
    },
    [OrganizationTypeWithLinkedProfessions.hospital]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.hospital],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.hospital],
    },
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.ksyosHospital],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.ksyosHospital
        ],
    },
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.optometryPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.optometryPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]: {
        ...supervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice
        ],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.ggzInstitution],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.ggzInstitution
        ],
    },
    [OrganizationTypeWithLinkedProfessions.independentPractice]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.independentPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.independentPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.addictionCareCentre],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.addictionCareCentre
        ],
    },
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.dietitianPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.dietitianPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.nursingFacility],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.nursingFacility
        ],
    },
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.skinTherapyPractice],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.skinTherapyPractice
        ],
    },
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {
        ...supervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory
        ],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory
        ],
    },
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare
        ],
    },
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {
        ...supervisorRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.psychiatryCenter],
        ...identifierDeclarationOrSupervisorRequiredByOrganizationType[
            OrganizationTypeWithLinkedProfessions.psychiatryCenter
        ],
    },
};

export const supervisorAllowed = [...identifierDeclarationOrSupervisorRequired, ...supervisorRequired];

export const zorgmailNummerRequiredByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {
        basicPractitioner: Profession.basicPractitioner,
        generalPractitioner: Profession.generalPractitioner,
        generalPractitionerAios: Profession.generalPractitionerAios,
        generalPractitionerHidha: Profession.generalPractitionerHidha,
        generalPractitionerMentalHealthSpecialist: Profession.generalPractitionerMentalHealthSpecialist,
        generalPractitionerWaarnemer: Profession.generalPractitionerWaarnemer,
    },
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {
        basicPractitioner: Profession.basicPractitioner,
        generalPractitioner: Profession.generalPractitioner,
        generalPractitionerAios: Profession.generalPractitionerAios,
        generalPractitionerHidha: Profession.generalPractitionerHidha,
        generalPractitionerMentalHealthSpecialist: Profession.generalPractitionerMentalHealthSpecialist,
        generalPractitionerWaarnemer: Profession.generalPractitionerWaarnemer,
    },
    [OrganizationTypeWithLinkedProfessions.hospital]: {},
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {},
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {},
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: {},
    [OrganizationTypeWithLinkedProfessions.independentPractice]: {},
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {},
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {},
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {},
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {},
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {},
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {},
};

export const zorgmailNummerRequired = [
    Profession.generalPractitioner,
    Profession.generalPractitionerAios,
    Profession.generalPractitionerHidha,
    Profession.generalPractitionerMentalHealthSpecialist,
    Profession.generalPractitionerWaarnemer,
];

export const zorgmailNummerAllowedByOrganizationType = {
    [OrganizationTypeWithLinkedProfessions.gpPractice]: {
        ...zorgmailNummerRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.gpPractice],
        nurse: Profession.nurse,
        nursePractitionerMentalHealth: Profession.nursePractitionerMentalHealth,
        nursePractitionerSomatic: Profession.nursePractitionerSomatic,
        nurseSpecialist: Profession.nurseSpecialist,
        physicianAssistant: Profession.physicianAssistant,
        practiceManager: Profession.practiceManager,
    },
    [OrganizationTypeWithLinkedProfessions.testOrganization]: {
        ...zorgmailNummerRequiredByOrganizationType[OrganizationTypeWithLinkedProfessions.testOrganization],
        nurse: Profession.nurse,
        nursePractitionerMentalHealth: Profession.nursePractitionerMentalHealth,
        nursePractitionerSomatic: Profession.nursePractitionerSomatic,
        nurseSpecialist: Profession.nurseSpecialist,
        physicianAssistant: Profession.physicianAssistant,
        practiceManager: Profession.practiceManager,
    },
    [OrganizationTypeWithLinkedProfessions.hospital]: {},
    [OrganizationTypeWithLinkedProfessions.ksyosHospital]: {},
    [OrganizationTypeWithLinkedProfessions.optometryPractice]: {},
    [OrganizationTypeWithLinkedProfessions.psychologyPracticePsychotherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.ggzInstitution]: {},
    [OrganizationTypeWithLinkedProfessions.independentPractice]: {},
    [OrganizationTypeWithLinkedProfessions.addictionCareCentre]: {},
    [OrganizationTypeWithLinkedProfessions.dietitianPractice]: {},
    [OrganizationTypeWithLinkedProfessions.nursingFacility]: {},
    [OrganizationTypeWithLinkedProfessions.skinTherapyPractice]: {},
    [OrganizationTypeWithLinkedProfessions.medicalDiagnosticCenterLaboratory]: {},
    [OrganizationTypeWithLinkedProfessions.centerForMedicalSpecialistCare]: {},
    [OrganizationTypeWithLinkedProfessions.psychiatryCenter]: {},
};

export const zorgmailNummerAllowed = [
    ...zorgmailNummerRequired,
    Profession.nursePractitionerSomatic,
    Profession.nursePractitionerMentalHealth,
    Profession.nurseSpecialist,
    Profession.physicianAssistant,
    Profession.practiceManager,
];

export const professionSpecialismCodes = new Map([[Profession.audiologist, SpecialismCode.audiology]]);

export const specialismRequired: Profession[] = [Profession.medicalSpecialist];
